module.exports = __webpack_public_path__ + "img/passMan.a8935c0f.svg";